import React, { useState } from 'react';
import './PostForm.scss';

export function PostForm({ disabled, onCancel, onPost }) {
  const [comment, setComment] = useState('');

  function onCommentChange(e) {
    setComment(e.target.value);
  }

  function onSubmit(e) {
    e.preventDefault();
        
    setComment('');
    onPost(comment);
  }

  return (
    <form className="PostForm" onSubmit={onSubmit}>
      <label
        className="PostForm__label"
        htmlFor="comment"
      >
        Comment
      </label>
      <textarea
        required
        id="comment"
        cols="45"
        rows="3"
        maxLength="65525"
        value={comment}
        className="PostForm__textarea"
        onChange={onCommentChange}
      />
      <div className="PostForm__actions">
        {onCancel && (
          <button
            type="button"
            className="PostForm__btn"
            onClick={onCancel}
          >
            Cancel
          </button>
        )}
        <button
          disabled={disabled}
          className="PostForm__btn"
          onClick={() => {
            console.log({
              "text": comment,
              "url": window.location.href
            })
            // actid=22
            window.analytics?.track("submit_comment:click", {
              "text": comment,
              "url": window.location.href
            });
          }}
        >
          Submit Comment
        </button>
      </div>
    </form>
  );
}
